module.exports = global["MobileDetect"] = require("-!./mobile-detect.js");


//////////////////
// WEBPACK FOOTER
// ./~/mobile-detect/mobile-detect.js-exposed
// module id = 759
// module chunks = 1